var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",attrs:{"id":"other"}},[_c('div',{staticClass:"container"},[_c('navbar'),_c('main',{staticClass:"xg-main"},[_c('router-view')],1),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('p',[_vm._v("©Company 2020-2021   "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("沪ICP备2021023648号-1")])])])
}]

export { render, staticRenderFns }